export default __webpack_public_path__ + "fcd94627cb1ffb6d6e6a42c195702f08.png";